<div class="testquestions-tbl">
	@if (!disabled) {
		@if (isNewOpen) {
			<ng-container
				*ngTemplateOutlet="fields; context: { curRow: newItem, isNewRow: true }"
			/>
		} @else {
			<button
				class="btn btn-icon justify-content-start"
				(click)="isNewOpen = true"
				titleLang="add"
				icon="add"
				isImg
			></button>
		}
	}
	@for (item of items; track item) {
		<ng-container *ngTemplateOutlet="fields; context: { curRow: item }" />
	}
</div>
<ng-template
	#fields
	let-curRow="curRow"
	let-isNewRow="isNewRow"
>
	<div
		[class.new-row]="isNewRow"
		class="question-container d-flex flex-column flex-sm-row gap-2 pb-3"
		style="border-bottom: 1px solid var(--light-green)"
	>
		<div class="d-flex flex-sm-column gap-2">
			<div class="d-flex gap-2 align-items-center">
				<app-spin-or-content [isSpin]="curRow.isFlipOrderSending">
					@if (!isNewRow && !disabled) {
						<div class="up-down-wrapper">
							@if (!curRow.is_lowest_order) {
								<app-icon
									icon="arrow_up"
									(click)="moveOrderNum(curRow, true)"
									titleLang="forward"
								/>
							}
							@if (!curRow.is_highest_order) {
								<app-icon
									icon="arrow_down"
									(click)="moveOrderNum(curRow, false)"
									titleLang="backward"
								/>
							}
						</div>
					}
				</app-spin-or-content>
			</div>
		</div>
		<div style="display: grid" 	class="d-flex justify-content: space-between gap-2 w-100"
		>
			<div class="policy-field">
				<label>{{ "question" | langVal }}</label>
				<app-wysiwyg
					[isStatic]="disabled"
					fieldName="question"
					[actualObj]="curRow"
					[errors]="curRow.errors"
					(keyupEvent)="validateEntireForm(curRow, true)"
					(changeEvent)="validateEntireForm(curRow)"
				/>
			</div>
			<div
				class="question-options d-flex flex-column flex-sm-row gap-2 align-items-end policy-field"
				style="border: 0.2px solid var(--grey)"
			>
				<div
					class="d-flex flex-column gap-2 flex-grow-1"
					style="align-self: flex-start"
				>
					<div class="d-flex gap-5">
						<div class="answer-type colstat-small">
							<label>{{ "field_type" | langVal }}</label>
							@if (disabled) {
								{{ curRow.field_type | langVal }}
							} @else {
								<app-gen-select
									optionFieldId="value"
									[actualObj]="curRow"
									fieldName="field_type"
									(changeEvent)="validateEntireForm(curRow)"
									optionsListName="policy_form_version_field_types"
								/>
							}
						</div>
						<div
							class="answer-required"
							style="margin-inline-start: auto"
						>
							<label>{{ "required" | langVal }}</label>
							<app-gen-button-group
								[disabled]="disabled"
								[actualObj]="curRow"
								fieldName="required"
								optionsListName="requiredOpts"
								title_ph_lang="required"
								(changeEvent)="validateEntireForm(curRow)"
							/>
						</div>
					</div>

					@if (curRow.field_type != "text" && curRow.field_type != "remark") {
						<div class="answer-suboptions d-flex flex-column gap-2">
							@for (opt of curRow.optionsArr; track opt) {
								<div class="d-flex gap-4 align-items-end">
									@if (!disabled) {
										<div class="up-down-wrapper actions sort-action">
											@if (opt.order_num > 1) {
												<app-icon
													icon="arrow_up"
													(click)="moveOptOrderNum(curRow, opt, true)"
												/>
											}
											@if (!opt.is_highest_order) {
												<app-icon
													icon="arrow_down"
													(click)="moveOptOrderNum(curRow, opt, false)"
												/>
											}
										</div>
									}
									<div class="flex-grow-1">
										<label>{{ "vvalue" | langVal }}</label>
										<app-gen-input
											#optValue
											[disabled]="disabled"
											fieldName="value"
											[actualObj]="opt"
											title_ph_lang="vvalue"
											[dataRowField]="(curRow?.id || 0) + '_' + opt.order_num"
											(changeEvent)="validateEntireForm(curRow)"
											(keyupEvent)="validateEntireForm(curRow, true)"
										/>
									</div>
									@if (!disabled) {
										<div>
											<button
												class="btn btn-icon"
												tabindex="-1"
												(click)="removeOpt(curRow, opt)"
												icon="delete"
											></button>
										</div>
									}
								</div>
							}
							@if (!disabled) {
								<div
									class="d-flex mx-4"
									style="text-align: center; margin-top: 23px"
								>
									<button
										class="btn btn-primary"
										(click)="addOpt(curRow)"
										tabClick
									>
										{{ "add_option" | langVal }}
									</button>
								</div>

								@if (curRow.errors?.options) {
									<p class="error">{{ curRow.errors?.options }}</p>
								}
							}
						</div>
					}
				</div>
				@if (!disabled) {
					<app-spin-or-content
						[isSpin]="curRow.isDeleting"
						style="margin-inline-start: auto"
					>
						@if (isNewRow) {
							<app-btn-ext
								text="add"
								(clickEv)="saveNewItem()"
								[disabled]="!curRow.isFormSubmittable"
								[isSpin]="isNewSaving"
							/>
						} @else {
							<button
								class="btn btn-icon"
								(click)="deleteItem(curRow)"
								titleLang="delete"
								icon="delete"
							></button>
						}
					</app-spin-or-content>
				}
			</div>
		</div>
	</div>
</ng-template>
@switch (modalProps?.name) {
	@case ("confirm-delete") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="do_you_confirm_delete"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="handleDeleteApprove($event)"
				[objectName]="modalProps.objectName"
			/>
		</app-modal-wrap>
	}
}
